import { render, staticRenderFns } from "./SysCategoryCarModal.vue?vue&type=template&id=dca18948&"
import script from "./SysCategoryCarModal.vue?vue&type=script&lang=js&"
export * from "./SysCategoryCarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports